import { css } from "@linaria/core";
import React, { InputHTMLAttributes, useRef } from "react";

import tickIcon from "@assets/icon/tick-white.svg";
import { styled } from "@linaria/react";
import { themeDefault } from "src/theme-revamp";

interface ICheckBox extends InputHTMLAttributes<HTMLInputElement> {
  checked: boolean;
  label: string;
  style?: any;
  name: string;
  checkBoxBGColor?: string;
}

function CheckBox({
  className: styling,
  ...props
}: React.PropsWithChildren<ICheckBox>) {
  return (
    <>
      <div className={`${style} ${styling}`}>
        <input
          {...props}
          id={props.name}
          style={{ opacity: 0, height: "0px", width: "0px" }}
          type={"checkbox"}
          onChange={(e) => {
            props.onChange && props.onChange(e);
          }}
          checked={props.checked}
        />
        <label htmlFor={props.name} className={style}>
          <CheckBoxTick
            checked={props.checked}
            checkBoxBGColor={props.checkBoxBGColor}
          >
            <img
              src={tickIcon}
              style={{ display: props.checked ? "block" : "none" }}
              alt="checkbox"
            />
          </CheckBoxTick>
          <LabelText checked={props.checked}>
            {props.children || props.label || "Input Checkbox Label"}
          </LabelText>
        </label>
      </div>
    </>
  );
}
const LabelText = styled.span<{ checked: boolean }>`
  display: inline-flex;
  margin-left: 16px;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: ${(prop) => (prop.checked ? "#000" : themeDefault.colors.grey[500])};
  height: 24px;
  transition: color 0.1 linear;
`;
const CheckBoxTick = styled.span<{
  checkBoxBGColor?: string;
  checked: boolean;
}>`
  background-color: ${(prop) =>
    prop.checked
      ? prop.checkBoxBGColor || themeDefault.colors.primary
      : "#FFF"};
  box-sizing: border-box;
  height: 24px;
  width: 24px;
  border-radius: 4px;
  border: ${(props) => (props.checked ? "none" : "#D8D8D8 1px solid")};
  padding: 4px;
  display: inline-block;
  transition: background-color 0.1s linear;
  position: relative;
  img {
    position: absolute;
    top: 10%;
    left: 10%;
  }
`;
const style = css`
  display: flex;
  cursor: pointer;
  input:focus-visible + & {
  }
`;

export default React.memo(CheckBox);
